export default __webpack_public_path__ + "static/gdpr-badge-a9d70e08c50ce16ffa20389e4d45062f.svg";